import React from 'react';
import { connect } from 'react-redux';

import { Theme, createStyles, withStyles } from '@material-ui/core';
import AddBox from '@material-ui/icons/AddBox';
import { FormControl } from '@material-ui/core';

import style from './commonComponentsStyle.module.css';
import DeliveryCompany from '../../models/DeliveryCompany';
import ForwarderModel from '../../models/ForwarderAwb';
import Select from 'react-select';

const iconFontSize = 40;
const useStyles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    formControl: {
      width: '350px',
      marginTop: '5px',
      marginRight: '20px'
    },
    formControlFWd: {
      width: '86%',
    },
    selectcss:{
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control':{
        borderColor: 'inherit',
        borderRadius: 'var(--ip-br)',
        fontSize: '12px',
        minHeight: '31px !important',
        boxShadow: 'none',
        '&:hover':{
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator':{
        display: 'none'
      }
    },
    label: {
      minWidth: '355px'
    },
    disabledButtonWrapper: {
      display: 'none'
    }
  });

interface CompanyDropDownProps {
  classes: any;
  items: Array<DeliveryCompany | ForwarderModel>;
  value: number | undefined ;
  openModal: () => void;
  allowedToChange?: boolean;
  onChange: (event: any) => void;
  valiant?: string ;
  labelText: string;
  type: 'truckingCompany' | 'fwdCompany';
  error?: string;
  onClick?: (event: any) => void;
  hasCreateNewCompany?: boolean;
  isEditMode: boolean;
};

interface Option {
  value: number;
  label: string;
};

const companyDropDown = (props: CompanyDropDownProps) => {

  const { classes } = props;
  const options: Array<Option> = props.items.map((item: any) => (
    {
      value: item.id,
      label: item.name
    }
  ));

  const getForwarderValue = (): Option => {
   const value: Array<Option> = options.filter((fwd: any) => fwd.value === props.value);
   return value[0];
  }

  const disabled = (props.type === 'truckingCompany' && !props.allowedToChange)?  true : false;
  const onClick = (props.type === 'truckingCompany')? (props.allowedToChange ? props.openModal : undefined ) : props.openModal;
  const dropDownWrapper: string = props.type === 'truckingCompany' ? style.dropDownTruckWrapper : style.dropDownFwdWrapper;
  const formControl: string = props.type === 'fwdCompany' ? classes.formControlFWd : classes.formControl;
  const styleSelect:  string = props.type === 'fwdCompany' ? classes.select : '';
  const selectValue: any = props.value ? getForwarderValue() : null;
  const shouldShowAddIcon: boolean = props.type === 'fwdCompany' ? false : true;
  return (
      <div className={ dropDownWrapper }>
        <FormControl
          required={ !props.isEditMode }
          className= { `${ formControl } ${ classes.selectcss }` } >
          <Select 
            onChange={ props.onChange }
            isDisabled={ disabled || props.isEditMode }
            options={ options }
            className={ styleSelect }
            value={ selectValue  }
            placeholder={ props.labelText }
            onClick={ props.onClick }
          />
        </FormControl>
        { !props.hasCreateNewCompany && !props.isEditMode &&
          <div className={ `${ style.buttonWrapper } ${ shouldShowAddIcon ? '' : classes.disabledButtonWrapper }` }>
            <AddBox color="primary" className={ classes.materialIcon } onClick={ onClick } />
          </div>
        }
      </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isEditMode: state.manualEntryEdit.isEditMode
  }
}
  
export default withStyles(useStyles)(connect(mapStateToProps, {})(companyDropDown));
